import React from "react";
import { Lock, Phone, MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const MILKADO_PHONE = "+243846103822";
const MILKADO_WHATSAPP = "243846103822";

/**
 * Bandeau affiché sur la page événement quand les achats sont gelés (J-48h).
 * Propose à l'invité de contacter Milkado pour un cadeau de dernière minute.
 */
export default function FrozenBanner({ event }) {
  const { t } = useLanguage();
  if (!event?.frozen) return null;

  const waMessage = (t("event.frozenWhatsappMsg") || "")
    .replace("{code}", event.code || "")
    .replace("{title}", event.title || "");
  const waHref = `https://wa.me/${MILKADO_WHATSAPP}?text=${encodeURIComponent(waMessage)}`;
  const telHref = `tel:${MILKADO_PHONE}`;

  return (
    <div
      data-testid="event-frozen-banner"
      className="mt-6 rounded-2xl border border-[#F2E2EC] bg-white p-5 sm:p-6 shadow-sm"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#FCE7F3] text-[#D81B8C] flex items-center justify-center shrink-0">
          <Lock className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-lg font-black text-[#2A0E3C] leading-tight">
            {t("event.frozenTitle")}
          </h3>
          <p className="mt-1 text-sm text-[#5C4664] leading-relaxed">
            {t("event.frozenBody")}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="frozen-whatsapp-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#3FA535] hover:bg-[#2E7E27] text-white px-4 h-10 text-sm font-semibold transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              {t("event.frozenCtaWhatsapp")}
            </a>
            <a
              href={telHref}
              data-testid="frozen-call-cta"
              className="inline-flex items-center gap-2 rounded-full bg-white border border-[#F2E2EC] hover:border-[#D81B8C] text-[#2A0E3C] px-4 h-10 text-sm font-semibold transition-colors"
            >
              <Phone className="w-4 h-4 text-[#D81B8C]" />
              {t("event.frozenCtaCall")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
